import { render, staticRenderFns } from "./CreateNotifySchool.vue?vue&type=template&id=f8202c3e&scoped=true"
import script from "./CreateNotifySchool.vue?vue&type=script&lang=js"
export * from "./CreateNotifySchool.vue?vue&type=script&lang=js"
import style0 from "./CreateNotifySchool.vue?vue&type=style&index=0&id=f8202c3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8202c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8202c3e')) {
      api.createRecord('f8202c3e', component.options)
    } else {
      api.reload('f8202c3e', component.options)
    }
    module.hot.accept("./CreateNotifySchool.vue?vue&type=template&id=f8202c3e&scoped=true", function () {
      api.rerender('f8202c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifySchool/CreateNotifySchool.vue"
export default component.exports